import { Component, OnInit, OnDestroy, isDevMode } from '@angular/core';
import { LanguageService } from './services/language/language.service';
import { AuthService, StorageService, MessageService, SessionService } from './services';
import { initFlowbite } from 'flowbite';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { UserSortType } from './models/enums';
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { firebaseConfig } from 'src/environments/environment';
import { DEFAULT_SUGGESTION_SORT } from './filters';
import { SuggestionService } from './services/suggestion/suggestion.service';
import { APP } from 'src/app/config/app';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  public title = 'Backoffice client';
  public initialized = false;

  public routeName = '';

  constructor(
    private languageService: LanguageService,
    private storageService: StorageService,
    private messageService: MessageService,
    private suggestionService: SuggestionService,
    private authService: AuthService,
    private router: Router,
    private sessionService: SessionService,
    public location: Location,
  ) {
    storageService.onRouteNameChange$.subscribe(() => {
      this.getRouteName();
    })
  }

  async ngOnInit() {
    try {
      const browserLocale = navigator.language.split('-')[0] || navigator.language;
      const storedLanguage = (await this.storageService.getLanguage()) || browserLocale;
      this.languageService.setDefaultLanguage(storedLanguage);
      await this.languageService.setLanguage(storedLanguage);

      await this.restoreSession();
    } finally {
      this.initialized = true;
      this.setDefaultData();
      initFlowbite();
      const app = initializeApp(firebaseConfig);
      getAnalytics(app);
    }
  }

  private async restoreSession() {
    if (!(await this.sessionService.restore())) {
      this.authService.clearStorage();
      this.storageService.clearStorage();
      this.router.navigate(['/'], { replaceUrl: true });
      return;
    }
    await this.getToken();
  }

  async getToken() {
    const token = await this.authService.getToken();
    if (!token) {
      await this.setRouteName(APP.DEFAULT_ROUTE);
      return;
    }
    // signInRedirectGuard sends the root url to the stored route, so only the label is left to sync.
    if (!this.location.path()) {
      await this.setRouteName(localStorage.getItem(APP.LOCAL_STORAGE_LAST_ROUTE) || APP.DEFAULT_ROUTE);
    }
    this.messageService.startPolling();
    this.suggestionService.startPolling();
  }

  async setDefaultData() {
    const savedUserSort = await this.storageService.getUserSortType();
    if (!savedUserSort) await this.storageService.setUserSortType(UserSortType.CREATION);
    const savedSuggestionSort = await this.storageService.getSuggestionsSortType();
    if (!savedSuggestionSort) await this.storageService.setSuggestionsSortType(DEFAULT_SUGGESTION_SORT);
  }

  public showNotification() {
    return true;
    // return configureStore.getState().notification.show
  }

  public async setRouteName(routeName: string) {
    this.routeName = routeName;
    await this.storageService.setRouteName(routeName);
    this.getRouteName();
  }

  public async getRouteName() {
    this.routeName = await this.storageService.getRouteName() || '';
  }

  ngOnDestroy() {
    this.messageService.stopPolling();
    this.suggestionService.stopPolling();
  }
}
